import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { LicenseModuleService360Component } from "./service360/service360.component";
import { LicensePortalRoutingModule } from "./license-portal-routing.module";
import { LicensePortalComponent } from "./license-portal.component";
import { AppSidenavComponent } from "../layout/sidenav/sidenav.component";
import { AppHeaderComponent } from "../layout/header/header.component";
import { AppFooterComponent } from "../layout/footer/footer.component";
import { LicenseSideNavComponent } from "../layout/license-sidenav/license-sidenav.component";
import { LicenseModuleGltComponent } from "./glt/glt.component";
import { LicenseModuleLz30Component } from "./lz30/lz30.component";
import { LicenseModuleScal360Component } from "./scal360/scal360.component";
import { LicenseModuleSmartcal360Component } from "./smartcal360/smartcal360.component";
import { LicenseModuleSmartlink360Component } from "./smartlink360/smartlink360.component";
import { CommonModule } from "@angular/common";
import { MaterialModule, MdSidenavModule } from "@angular/material";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GenerateService360LicenseComponent } from "./service360/generate-service360-license/generate-service360-license.component";
import { GenerateGltLicenseComponent } from "./glt/generate-glt-license/generate-glt-license.component";
import { LicenseFilterPipe } from "./filter.pipe";
import { GenerateSmartLink360LicenseComponent } from "./smartlink360/generate-smartlink360-license/generate-smartlink360-license.component";
import { Service360FilterPipe } from "./service360/pipes/service360FilterPipe";
import { Service360ViewActivationDetailComponent } from "./service360/service360-view-activation-details/service360-view-activation-details.component";
import { SmartLink360ViewActivationDetailComponent } from "./smartlink360/smartlink360-view-activation-details/smartlink360-view-activation-details.component";
import { FaqComponent } from "./faq/faq.component";
import { AddEditFaqComponent } from "./faq/add-edit-faq/add-edit-faq.component";
import { Lz30DeviceInfoFilterPipe } from "./lz30/pipes/lz30DeviceInfoFilterPipe";
import { AddEditLZ30DeviceComponent } from "./lz30/add-lz30-device/add-lz30-device.component";
import { AddLz30DeviceLicenseRequest } from "./lz30/add-lz30-device-license-request/add-lz30-device-license-request.component";
import { LZ30PurchaseLicenseFilterPipe } from "./lz30/pipes/lz30PurchaseLicenseFilterPipe";
import { ViewLZ30PurchaseLicenseHistory } from "./lz30/view-lz30-purchase-history/view-lz30-purchase-history.component";
import { GenerateSCAL30LicenseComponent } from "./scal360/generate-scal360-license/generate-scal360-license.component";
import { ActivateScal360LicenseComponent } from "./scal360/activate-scal360-license/activate-scal360-license.component";
import { RenewScal360LicenseComponent } from "./scal360/renew-scal360-license/renew-scal360-license.component";
import { ViewScal360LicenseInformationComponent } from "./scal360/view-scal360-license-information/view-scal360-license-information.component";
import { Scal360FilterPipe } from "./scal360/pipes/scal360FilterPipe";
import { ViewScal360PurchaseHistoryComponent } from "./scal360/view-scal360-purchase-history/view-scal360-purchase-history.component";
import { ViewScal360RenewalHistoryComponent } from "./scal360/view-scal360-renewal-history/view-scal360-renewal-history.component";
import { ViewScal360ActivationHistoryComponent } from "./scal360/view-scal360-activation-history/view-scal360-activation-history.component";
import { ViewScal360DownloadReleaseHistoryComponent } from "./scal360/view-scal360-download-release-history/view-scal360-download-release-history.component";
import { AssignSmartCal360NCustomerComponent } from "./smartcal360/assign-smartcal360n-customer/assign-smartcal360n-customer.component";
import { Smartlink360RenewLicenseComponent } from "./smartlink360/smartlink360-renew-license/smartlink360-renew-license.component";
import { ImportFaqComponent } from "./faq/import-faq/import-faq.component";
import { SmartLink360ViewRenewalHistoryComponent } from "./smartlink360/smartlink360-view-renewal-history/smartlink360-view-renewal-history.component";
import { SmartLink360ViewFeedbackComponent } from "./smartlink360/smartlink360-view-feedback/smartlink360-view-feedback.component";
import { LicenseService } from "../services/LicenseService";
import { ExtendLZ30TrialPeriod } from "./lz30/extend-LZ30-trial-period/extend-LZ30-trial-period.component";
import { ViewLZ30DeviceHistory } from "./lz30/view-lz30-device-history/view-lz30-device-history.component";
import { SearchableDropdownComponent } from "../layout/searchable-dropdown/searchable-dropdown.component";
import { SortDropdownComponent } from "../layout/sort-dropdown/sort-dropdown.component";
import { SmartCal360FilterPipe } from "./smartcal360/pipes/smartcal360FilterPipe";
import { SmartCal360AssignCustomerFilterPipe } from "./smartcal360/pipes/smartcal360AssignCustomerPipe";
import { LicenseModuleSyncITComponent } from "./syncit/syncit.component";
import { SyncITFilterPipe } from "./syncit/pipes/SyncITFilterPipe";
import { GenerateSyncITLicenseComponent } from "./syncit/popup/generate-syncit-license/generate-syncit-license.component";
import { ExtendSyncItTrialPeriodComponent } from "./syncit/popup/extend-trial-period/extend-trial-period.component";
import { AddMoreSyncItLicenseComponent } from "./syncit/popup/addmore-syncit-license/addmore-syncit-license.component";
import { RenewSyncItComponent } from "./syncit/popup/renew-syncit-license/renew-syncit-license.component";
import { ViewSyncItHistoryComponent } from "./syncit/popup/view-history-popup/view-history-popup.component";
import { LicenseModuleGIS360Component } from "./gis360/gis360.component";
import { GenerateGIS360LicenseComponent } from "./gis360/popup/generate-gis360-license/generate-gis360-license.component";
import { GIS360FilterPipe } from "./gis360/pipes/gis360FilterPipe";
import { RenewGIS360LicenseComponent } from "./gis360/popup/renew-gis360-license/renew-gis360-license.component";
import { ViewGIS360RenewalHistoryComponent } from "./gis360/popup/view-gis360-renewal-history/view-gis360-renewal-history.component";
import { ViewGIS360LicenseInformationComponent } from "./gis360/popup/view-gis360-license-information/view-gis360-license-information.component";
import { ActivateGIS360LicenseComponent } from "./gis360/popup/activate-gis360-license/activate-gis360-license.component";
import { ViewGIS360ActivationDetailsComponent } from "./gis360/popup/view-gis360-activation-details/view-gis360-activation-details.component";

@NgModule({
  imports: [
    LicensePortalRoutingModule,
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MdSidenavModule,
  ],
  declarations: [
    LicenseFilterPipe,
    Service360FilterPipe,
    Lz30DeviceInfoFilterPipe,
    LZ30PurchaseLicenseFilterPipe,
    Scal360FilterPipe,
    LicenseModuleService360Component,
    LicenseModuleGltComponent,
    LicenseModuleLz30Component,
    LicenseModuleScal360Component,
    LicenseModuleSmartcal360Component,
    LicenseModuleSmartlink360Component,
    GenerateService360LicenseComponent,
    GenerateGltLicenseComponent,
    GenerateSmartLink360LicenseComponent,
    Service360ViewActivationDetailComponent,
    SmartLink360ViewActivationDetailComponent,
    FaqComponent,
    AddEditFaqComponent,
    AddEditLZ30DeviceComponent,
    ViewLZ30DeviceHistory,
    ExtendLZ30TrialPeriod,
    AddLz30DeviceLicenseRequest,
    ViewLZ30PurchaseLicenseHistory,
    GenerateSCAL30LicenseComponent,
    ActivateScal360LicenseComponent,
    RenewScal360LicenseComponent,
    ViewScal360LicenseInformationComponent,
    ViewScal360PurchaseHistoryComponent,
    ViewScal360RenewalHistoryComponent,
    ViewScal360ActivationHistoryComponent,
    ViewScal360DownloadReleaseHistoryComponent,
    AssignSmartCal360NCustomerComponent,
    Smartlink360RenewLicenseComponent,
    ImportFaqComponent,
    SmartLink360ViewRenewalHistoryComponent,
    SmartLink360ViewFeedbackComponent,
    SearchableDropdownComponent,
    SortDropdownComponent,
      LicenseModuleSyncITComponent,
    GenerateSyncITLicenseComponent,
    ExtendSyncItTrialPeriodComponent,
    AddMoreSyncItLicenseComponent,
    RenewSyncItComponent,
    ViewSyncItHistoryComponent,
    SyncITFilterPipe,
    LicenseModuleGIS360Component,
    GenerateGIS360LicenseComponent,
    RenewGIS360LicenseComponent,
    ViewGIS360RenewalHistoryComponent,
    ViewGIS360LicenseInformationComponent,
    ActivateGIS360LicenseComponent,
    ViewGIS360ActivationDetailsComponent,
    GIS360FilterPipe,
  ],
  providers: [
    LicenseService,
    Scal360FilterPipe,
    Service360FilterPipe,
    Lz30DeviceInfoFilterPipe,
    LZ30PurchaseLicenseFilterPipe,
    LicenseFilterPipe,
    SmartCal360FilterPipe,
    SmartCal360AssignCustomerFilterPipe,
     SyncITFilterPipe,
    GIS360FilterPipe,
  ],
  entryComponents: [
    GenerateSyncITLicenseComponent,
    ExtendSyncItTrialPeriodComponent,
    AddMoreSyncItLicenseComponent,
    RenewSyncItComponent,
    ViewSyncItHistoryComponent,
    GenerateGIS360LicenseComponent,
    RenewGIS360LicenseComponent,
    ViewGIS360RenewalHistoryComponent,
    ViewGIS360LicenseInformationComponent,
    ActivateGIS360LicenseComponent,
    ViewGIS360ActivationDetailsComponent,
  ],
})
export class LicensePortalModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/license-portal.module.ts